'use strict';

const XLSX = require('../xlsx/xlsx');

class ModelContainer {
  constructor(model) {
    this.model = model;
  }

  get xlsx() {
    if (!this._xlsx) {
      this._xlsx = new XLSX(this);
    }
    return this._xlsx;
  }
}

module.exports = ModelContainer;
